import React from "react";
// ANT DESIGN COMPONENTS
import { Select } from "antd";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// INTERFACES
import { OpcCommandType } from "../../../interfaces/AdapterCdoOpc.interface";

export default function FormSelectOpcCommand({
	inputValue,
	inputOnChange,
	disabledInput,
	isValue,
}: {
	inputValue: string;
	inputOnChange: (newValue: OpcCommandType, isValue: boolean) => void;
	disabledInput: boolean;
	isValue: boolean;
}) {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	const { Option } = Select;
	const [t] = useTranslation("global");
	const OPTIONS: OpcCommandType[] = ["read_content_table", "write_content_table", "response_content_table"];

	// ************************************************ */
	// USE STATE VARIABLES **************************** */

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// FUNCTIONS ************************************** */

	// ************************************************ */
	// USE EFFECT ************************************* */

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<div className='col-md-12 mt-3'>
			<div className='generalStyles__flex'>
				<div className='generalStyles__inputFlexNameLarge'>
					<span className='generalStyles__inputFlexRequired'>*</span>
					<span>
						{isValue && "Value"} {t("general.opcCommand")}
					</span>
				</div>
				<div className='generalStyles__width100'>
					<Select
						className='generalStyles__width100'
						size='small'
						onChange={(e: any) => {
							inputOnChange(e, isValue);
						}}
						value={inputValue}
						disabled={disabledInput}
					>
						{OPTIONS.map((item: OpcCommandType) => (
							<Option key={item} value={item}>
								{item.replace(/_/g, " ")}
							</Option>
						))}
					</Select>
				</div>
				<div className='generalStyles__infoTooltipIconBlank' />
			</div>
		</div>
	);
}
